import React from "react";
import Spinner from "../Spinner";

const Heights = {
    none: "",
    small: "min-h-[15rem] h-full",
    medium: "min-h-[30rem] h-full",
    large: "min-h-[45rem] h-full",
};

const Widths = {
    full: "w-full",
    medium: "min-w-full md:min-w-[45rem]",
    none: "",
};

interface Props {
    height?: keyof typeof Heights;
    width?: keyof typeof Widths;
}

const ContainerSpinner = ({ height = "medium", width = "full" }: Props) => (
    <div className={`flex justify-center items-center ${Heights[height]} ${Widths[width]}`}>
        <Spinner width="4rem" height="4rem" color="text-mint-500" />
    </div>
);

export default ContainerSpinner;
